import React from "react";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
export const DashboardLayout = ({ banner, sidebar, children, contentRef, pageHeader, }) => {
    return (React.createElement(PeekStack, { width: "100%", height: "100vh", direction: "column", justifyContent: "space-between" },
        React.createElement(PeekStack, { direction: "row", sx: { width: "100%", flex: 1, minHeight: 0 } },
            sidebar,
            React.createElement(PeekBox, { ref: contentRef, sx: {
                    p: 2,
                    flex: 1,
                    overflowY: "auto",
                    backgroundColor: "grey.50",
                } },
                React.createElement(PeekStack, { gap: 3 }, pageHeader ? (React.createElement(PeekStack, { gap: 2 },
                    banner && banner,
                    pageHeader,
                    children)) : (React.createElement(PeekStack, { gap: 2 }, children)))))));
};
export default DashboardLayout;
